import Main from '../index'

export default {
  install (Vue, options = {}) {
    const Picker = Vue.extend(Main)
    function $rulesDiaolog (dataVal) {
      const data = {
        ...options,
        rulesVisible: true,
        ...dataVal
      }

      return new Promise((reslove) => {
        const vm = new Picker({
          propsData: data,
          created () {
            const destory = () => {
              this.$destroy()
              this.$el.remove()
            }

            this.$once('rulesVisibleChange', destory)
          }
        }).$mount()
        document.body.appendChild(vm.$el)
      })
    }

    Vue.prototype.$rulesDiaolog = $rulesDiaolog
  }
}
